import { JsonPipe } from '@angular/common';
import { Component, computed, input, ChangeDetectionStrategy, signal } from '@angular/core';
import { FieldState } from '@angular/forms/signals';

@Component({
  selector: 'app-debug-panel',
  imports: [JsonPipe],
  templateUrl: './debug-panel.component.html',
})
export class DebugPanelComponent {

  readonly form = input.required<FieldState<unknown>>();
  readonly formValue = computed(() => this.form().value());
  readonly formValid = computed(() => this.form().valid());
  readonly formDirty = computed(() => this.form().dirty());


  showDebugPanel = signal(window.location.href.toLowerCase().indexOf('localhost') > 0)

}
